import {
  SET_DATES,
  APPEND_TIMESLOT,
  SELECT_TIMESLOT,
  RESET_TIMESLOTS,
  INCREASE_MONTH,
  DECREASE_MONTH,
  CANCEL_FROM_UPCOMING_VISIT
} from './action-types'

export const setDates = payload => ({
  type: SET_DATES,
  payload
})

export const cancelFromUpcomingVisit = payload => ({
  type: CANCEL_FROM_UPCOMING_VISIT,
  payload
})

export const appendTimeslot = (payload, meta) => ({
  type: APPEND_TIMESLOT,
  payload,
  meta
})
export const selectTimeslot = (payload, meta) => ({
  type: SELECT_TIMESLOT,
  payload
})

export const increaseMonth = () => ({
  type: INCREASE_MONTH
})

export const decreaseMonth = () => ({
  type: DECREASE_MONTH
})

export const resetTimeslots = () => ({
  type: RESET_TIMESLOTS
})
